import { render } from "./Experience.vue?vue&type=template&id=1383d9aa"
import script from "./Experience.vue?vue&type=script&lang=js"
export * from "./Experience.vue?vue&type=script&lang=js"
script.render = render

export default script